function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 8,
  fill: "#DDE4FA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.15 12.6C12.15 12.3911 12.233 12.1908 12.3806 12.0432C12.5283 11.8955 12.7286 11.8125 12.9375 11.8125H23.7375C23.9463 11.8125 24.1466 11.8955 24.2943 12.0432C24.442 12.1908 24.525 12.3911 24.525 12.6V20.5875C24.525 20.7964 24.442 20.9967 24.2943 21.1443C24.1466 21.292 23.9463 21.375 23.7375 21.375H16.3125L13.3875 23.85C13.325 23.9219 13.2412 23.972 13.1484 23.9933C13.0555 24.0145 12.9583 24.0057 12.8707 23.9682C12.7832 23.9307 12.7098 23.8664 12.6611 23.7845C12.6125 23.7026 12.5911 23.6073 12.6 23.5125V21.375H12.15C11.9411 21.375 11.7408 21.292 11.5931 21.1443C11.4455 20.9967 11.3625 20.7964 11.3625 20.5875V12.6H12.15Z",
  stroke: "#2D3B78",
  strokeWidth: 1.3,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9625 15.075H21.0375M14.9625 17.1H21.0375M14.9625 19.125H18.5625",
  stroke: "#2D3B78",
  strokeWidth: 1.3,
  strokeLinecap: "round"
});

function SvgNewsfeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsfeed);
export default __webpack_public_path__ + "static/media/newsfeed.13602d12.svg";
export { ForwardRef as ReactComponent };